import { createStore } from 'vuex'

import parametersModule from '../store/modules/parameters.module'
import devicesModule from '../store/modules/devices.module'
import subscriptionsModule from './modules/subscriptions.module'
import usersModule from './modules/users.module'
import appcompatModule from './modules/appcompat.module'
import altmodeModule from './modules/altmode.module'

export default createStore({
  modules: {
    parameters: parametersModule,
    devices: devicesModule,
    subscriptions: subscriptionsModule,
    users: usersModule,
    appcompat: appcompatModule,
    altmode: altmodeModule,
  },
})
